import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { Router } from '@angular/router';
import { BreezeService } from 'src/app/shared/services/breeze.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  errorMessage: any;

  constructor(
    private breezeService: BreezeService,
    private notificationService: NotificationService,
    private router: Router,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // this.dialogService.openLoadingDialog();
    // 'skip-error-interceptor' is a signal for this interceptor only - it
    // must not be forwarded to the backend as a real HTTP header, since an
    // unrecognized custom header on a cross-origin request forces a CORS
    // preflight that most backends haven't allowlisted.
    const skipErrorInterceptor = request.headers.has('skip-error-interceptor');
    const outgoingRequest = skipErrorInterceptor
      ? request.clone({
          headers: request.headers.delete('skip-error-interceptor'),
        })
      : request;

    return next.handle(outgoingRequest).pipe(
      tap((evt: any) => {
        if (evt instanceof HttpResponse && !skipErrorInterceptor) {
          if (
            evt?.body?.error == true ||
            (evt?.body?.resultType && evt?.body?.resultType !== 1)
          ) {
            this.errorMessage = evt.body.message;
            this.notificationService.error('Error occured!', this.errorMessage);
          }
        }
        // this.dialogService.closeLoadingModal();
      }),

      catchError((error: HttpErrorResponse) => {
        if (skipErrorInterceptor) {
          return throwError(error.error);
        }
        if (error.error instanceof ErrorEvent) {
          //client-side error
          this.errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error
          switch (error.status) {
            case 503: {
              this.errorMessage = 'Internal Server Error.';
              this.notificationService.error(
                'Error occured!',
                this.errorMessage,
              );
              break;
            }
            case 500: {
              this.errorMessage = 'Internal Server Error.';
              this.notificationService.error(
                'Error occured!',
                this.errorMessage,
              );
              break;
            }
            case 400: {
              const title = error.url?.includes('verify_phone')
                ? 'Phone number not verified'
                : 'Error occured!';
              const errorMessage = error.error.message;
              this.notificationService.error(
                title,
                errorMessage ?? this.errorMessage,
              );
              break;
            }
            case 404: {
              this.errorMessage = 'Error, not found!';
              this.notificationService.error(
                'Error occured!',
                this.errorMessage,
              );
              break;
            }
            case 401: {
              this.errorMessage = 'Session Timed Out';
              this.notificationService.error(
                'Session Timed Out',
                this.errorMessage,
              );
              this.breezeService.logOut();
              // this.router.navigate(['/']);

              break;
            }
            case 403: {
              const _error = error as unknown as any;
              this.notificationService.error(
                'Error occured',
                _error?.error?.detail ?? 'Unauthorized',
              );
              this.router.navigate(['/']);
              break;
            }
            case 405: {
              this.errorMessage = 'Error, please try Again';
              this.notificationService.error(
                'Error occured',
                this.errorMessage,
              );
              break;
            }
            case 0: {
              this.errorMessage = 'Error, Check Internet Connection!';
              this.notificationService.error(
                'Error occured',
                this.errorMessage,
              );
              break;
            }
          }
        }
        // this.dialogService.closeLoadingModal();
        return throwError(error.error);
      }),
    );
  }
}
